<template>
    <Modal :show="showModal" @close="showModal = false" :inHeader="true" :modalClass="'popup-cart'" :class="{'fade-disable': isModalRegionActive}">
        <template #header>
            <h5 class="popup-cart__title">
                <img src="/img/popup-cart/cart-icn.svg" alt="cart-icn">
                <span>{{ $t('Product added to Cart') }}</span>
            </h5>
        </template>
        <template #body>
            <div class="modal-card">
                <div class="popup-cart__body">
                    <div class="popup-cart__items-list card-items">
                        <div class="popup-cart__item-list list-items" :class="{'active-scroll-height': !mobile}" v-if="cartCount > 0">
                            <ScrollFade fade-top-class="faded-top" fade-bottom-class="faded" :class="products.length === 1 ? 'no-fade' : ''">
                                <ModalAddToCartItem v-for="product in products" 
                                    :key="product.id" 
                                    :language="language"
                                    :isUserSeller="isUserSeller"
                                    :product="product" 
                                    :mobile="mobile"
                                    :cartCostProp="cartCost"
                                    :cartCountProps="cartCount"/>
                            </ScrollFade>
                        </div>
                    </div>
                </div>
                <div class="popup-cart__footer">
                    <div class="popup-cart__footer-slide-up"
                            @click="toggleInfo" 
                            @touchstart="handleTouchStart"
                            @touchend="handleTouchEnd"
                            v-if="mobile && (cartDataProp.user_offline || cartDataProp.delivery_comfort)"></div>
                    <SlideUpDown :isActive="isActiveToggleInfo" v-if="cartDataProp.user_offline || cartDataProp.delivery_comfort">
                        <div v-if="cartDataProp.user_offline" class="popup-cart__messages-container popup-cart__messages-container--bg">
                            <p class="popup-cart__alert-message">
                                {{ $t('You place an order with a seller who is currently offline.') }}
                                {{ $t('The delivery of your order may take longer than usual.') }}
                                {{ $t('Please be careful!') }}
                            </p>
                        </div>
                        <div v-if="cartDataProp.delivery_comfort" class="popup-cart__messages-container popup-cart__messages-container--bg">
                            <p class="popup-cart__alert-message">
                                {{ $t('The seller from whom you are about to place the order is not responsible for your current balance (coins) that are in your account.') }}
                                {{ $t('The seller guarantees and is only responsible for transferring the coins according to the order you placed.') }}
                                {{ $t('For added security to your account, please change your username/password after completing your order.') }}
                            </p>
                        </div>
                    </SlideUpDown>
                    <div class="popup-cart__full-price">
                        <div>
                            <span>{{ $t('Total amount') }}</span>
                            <span> :</span>
                        </div>
                        <span class="summ" :class="{discount: discountCartCost !== cartCost && discountCartCost && !isUserSeller}">
                            <span class="price-old">{{ cartCost }}</span>
                            <span v-if="discountCartCost !== cartCost && discountCartCost && !isUserSeller" class="price-new">{{ discountCartCost }}</span>
                        </span>

                        <PayButtons v-if="paymentMethods" :paymentMethods="paymentMethods" @pay="goToCheckout"/>
                    </div>
                
                    <div class="popup-cart__footer-decor"></div>
                
                    <div class="popup-cart__footer-btns">
                        <a class="popup-cart__footer-btn popup-cart__footer-btn--checkout btn button checkout btn-hover btn-hover--gray js-btn-preloader-gray-onClick"
                            href="/cart">
                                <span>{{ $t('View cart') }}</span>
                        </a>
                        <a v-if="cartDataProp.checkout" class="popup-cart__footer-btn popup-cart__footer-btn--continue btn button continue btn-hover btn-hover--green"
                            @click.prevent="handleCheckoutClick"    
                            href="/checkout">
                                <span>{{ $t('Go to checkout') }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </template>
    </Modal>
</template>
  
<script>
import ScrollFade from '/webpack-assets/vue/components/ScrollFade.vue';
import Modal from '/webpack-assets/vue/components/Modal.vue';
import Button from '/webpack-assets/vue/components/Button.vue';
import ModalAddToCartItem from './ModalAddToCartItem.vue';
import SlideUpDown from '/webpack-assets/vue/components/SlideUpDown.vue';
import PayButtons from '/webpack-assets/vue/templates/product/catalog/parts/PayButtons.vue';

  export default {
    name: 'ModalAddToCart',
    components: {
      ScrollFade,
      Modal,
      Button,
      ModalAddToCartItem,
      SlideUpDown,
      PayButtons,
    },
    props: {
        mobile: {
            type: Boolean,
            default: false,
        },
        isUserSeller: {
            type: Boolean,
            default: false,
        },
        language: {
            type: String,
            default: 'en',
        },
        cartCostProp: {
            type: String,
            default: ''
        },
        discountCartCostProp: {
            type: String,
            default: ''
        },
        cartDataProp: {
            type: Object,
            default: () => {},
        },
        isModalCartActiveProp: {
            type: Boolean,
            default: false,
        },
        isModalRegionActive: {
            type: Boolean,
            default: false,
        },
        isShowRegionModal: {
            type: Boolean,
            default: false,
        },
    },
    data() {
      return {
        showModal: false,
        cartCount: this.cartDataProp.count,
        cartCost: this.cartDataProp.cost,
        discountCartCost: this.cartDataProp?.discount_cost,
        isAvailableGoogle: this.cartDataProp?.is_available_google_pay,
        isAvailableApple: this.cartDataProp?.is_available_apple_pay,
        products: this.cartDataProp.items,
        isActiveToggleInfo: true,
        touchStartY: 0,
        touchEndY: 0,
        paymentMethods: {},
      };
    },
    mounted() {
        this.regulatePaymentMethods(this.cartDataProp.payment_methods);

        if(this.mobile) {
            this.isActiveToggleInfo = false
        }
    },
    methods: {
        toggleInfo() {
            if(this.mobile) {
                this.isActiveToggleInfo = !this.isActiveToggleInfo
            }
        },
        handleCheckoutClick() {
            if (this.isShowRegionModal) {
                this.$emit('modal-region-show');
            } else {
                window.location.href = '/checkout';
            }
        },
        handleTouchStart(event) {
            this.touchStartY = event.touches[0].clientY;
        },
        handleTouchEnd(event) {
            this.touchEndY = event.changedTouches[0].clientY;
            const swipeDistance = this.touchStartY - this.touchEndY;

            if (swipeDistance > 50) {
                this.toggleInfo();
            }
        },
        goToCheckout(methodId) {
            const checkoutUrl = methodId ? `/checkout?paymentMethodId=${methodId}` : '/checkout';
            window.location = checkoutUrl;
        },
        regulatePaymentMethods(payment_methods) {
            if (!payment_methods) return;
            this.paymentMethods = payment_methods.reduce((acc, method) => {
                acc[method.id] = method;
                return acc;
            }, {});
        }
    },
    watch: {
        isModalCartActiveProp() {
            this.showModal = this.isModalCartActiveProp;
        },
        showModal() {
            if(this.showModal === false) {
                this.$emit('close-modal-cart');
            }
        },
        cartCostProp() {
            this.cartCost = this.cartDataProp.cost;
            this.discountCartCost = this.cartDataProp?.discount_cost;
            this.products = this.cartDataProp.items;
            this.cartCount = this.cartDataProp.count;
            this.regulatePaymentMethods(this.cartDataProp.payment_methods);
            if(this.cartCost === this.discountCartCost) {
                this.discountCartCost = null;
            }
        },
    }
  };
  </script>

<style lang="scss">
.popup-cart{
    max-width: 700px !important;
    @media only screen and (max-width: 768px) {
        max-width: 100% !important;
        max-height: calc(100dvh - 44px) !important;
        height: calc(100dvh - 44px) !important;
        display: flex;
        flex-direction: column;
        position: static !important;
    }    
    .modal-header{
        padding-bottom: 20px !important;
    }
    .modal-body{
        padding: 0 0 30px;
        @media only screen and (max-width: 767px) {
            height: 100% !important;
            padding: 0;
        }   
    }
}
</style>